import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getReciept(idrecibo) {
  try {
    const response = await axios.post(`${import.meta.env.VITE_APP_API_URL}get-receipt`, { idrecibo },
      {
        responseType: 'arraybuffer',
      }
    );
    return response

  } catch (error) {
    console.error('Error al obtener el recibo del alumno', error);
  }
}